export enum TimeSyncStatus {
    Pending = 'Pending', // Not yet synchronized from server or fallback on local time
    Sync = 'Sync', // Successfully synchronized from server
    Local = 'Local', // Fallback on local time (server synchronization failed)
}
